<template>
  <i-select
    clearable
    placeholder="Выберите категории"
    v-model="selected"
    multiple
    :max-tag-count="1"
    @on-change="changeHandler"
    size="default"
  >
    <i-option v-for="item in allUITypes" :value="item.type" :key="item.type">
      {{ item.label }}
    </i-option>
  </i-select>
</template>

<script>
const allUITypes = [
  { type: 'contract', label: 'Договор' },
  { type: 'spec', label: 'Техническое задание' },
  { type: 'roadmap', label: 'Календарный план' },
  { type: 'estimate', label: 'Сметы' },
  { type: 'work_program', label: 'Программа работ' },
  { type: 'spec_account', label: 'Спец. счет' },
  { type: 'other', label: 'Прочее' }
]

export default {
  props: {
    contract: {
      type: Object,
      required: true
    },
    allFileTypes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: [],
      allUITypes
    }
  },
  methods: {
    changeHandler (values) {
      const newValues = []

      values.forEach((uiType) => {
        const ids = this.allFileTypes
          .filter((type) => type.ui_groups === uiType)
          .map((type) => type.id)

        ids.forEach((id) => {
          if (newValues.indexOf(id) === -1) {
            newValues.push(id)
          }
        })
      })

      this.$set(this.contract, 'mandatory_file_types', newValues)
    }
  },
  created () {
    this.contract.mandatory_file_types.forEach((id) => {
      const { ui_groups } = this.allFileTypes.find((type) => type.id === id)

      if (this.selected.indexOf(ui_groups) === -1) {
        this.selected.push(ui_groups)
      }
    })
  }
}
</script>

<style>
</style>
